import { proxy } from "valtio";
import { shoes } from "./config";

export const store = proxy({
  current: null,
  selectedShoeType: Object.keys(shoes)[0],
  items: {
    laces: "#FF0000", // Red
    mesh: "#000000", // Black
    caps: "#FFFFFF", // White
    inner: "#C0C0C0", // Silver
    sole: "#333333", // Dark Gray
    stripes: "#FFA500", // Orange
    band: "#800080", // Purple
    patch: "#006400", // Dark Green
  },
});
